<mat-form-field appearance="fill" class="searchable-multiselect">
  <mat-label>{{ label }}</mat-label>

  <mat-select
    multiple
    [value]="internalValue"
    (openedChange)="onOpened()"
  >
    <mat-select-trigger>
      {{ internalValue == null || internalValue.length == 0 ? 'none' : internalValue.join(',') }}
    </mat-select-trigger>

    <!-- Search box -->
    <mat-option disabled>
      <mat-form-field class="search-field" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input
          #searchInput
          matInput
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          (keydown.space)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          placeholder="Search..."
        />
      </mat-form-field>
    </mat-option>

    <!-- Filtered options -->
    <mat-option
      *ngFor="let option of filtered"
      [value]="option.value"
      (onSelectionChange)="onOptionToggle(option.value, $event.source.selected)"
    >
      <span [innerHTML]="highlightMatch(option.label + ' (' + option.value + ')')"></span>
    </mat-option>
  </mat-select>
</mat-form-field>
